import { Skeleton, SkeletonRegion } from '@parsina/framework';
import { C, RADIUS } from '@parsina/framework/tokens';
import { useTranslation } from '@parsina/framework/clinical/src/i18n/index';

// ─────────────────────────────────────────────────────────────────────────────
// The mobile accounting report's line-item region while the first page is
// pending. The MobileHeader, summary (`MobileAccountingSummary loading`) and
// filters render for real; each placeholder is one `MobileAccountingLineCard`
// — the type chip and date on top, the service title, the amount row — at the
// card's real `0.75rem 0.875rem` padding. The desktop table uses the kit's
// `SkeletonRow` under its real header instead.
// ─────────────────────────────────────────────────────────────────────────────

const LineCardSkeleton = ({ i }) => (
  <div aria-hidden style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: RADIUS.card, padding: '0.75rem 0.875rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Skeleton width={64} height={20} radius={RADIUS.chip} />
      <Skeleton width={72} height={11} />
    </div>
    <Skeleton width={`${48 + ((i * 17) % 32)}%`} height={14} />
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Skeleton width={`${26 + ((i * 11) % 20)}%`} height={11} />
      <Skeleton width={80} height={14} />
    </div>
  </div>
);

export const AccountingMobileLinesSkeleton = ({ count = 4, label }) => {
  const { t } = useTranslation();
  return (
    <SkeletonRegion label={label ?? t('common.state.loading')} data-testid="accounting-lines-loading" style={{ display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
      {Array.from({ length: count }, (_, i) => <LineCardSkeleton key={i} i={i} />)}
    </SkeletonRegion>
  );
};

export default AccountingMobileLinesSkeleton;
